import { render, staticRenderFns } from "./AgentComposition.vue?vue&type=template&id=46f68c68&scoped=true&"
import script from "./AgentComposition.vue?vue&type=script&lang=js&"
export * from "./AgentComposition.vue?vue&type=script&lang=js&"
import style0 from "./AgentComposition.vue?vue&type=style&index=0&id=46f68c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f68c68",
  null
  
)

export default component.exports